// extracted by mini-css-extract-plugin
export default {"button":"ScrollToTop_button__nVPyn","hidden":"ScrollToTop_hidden__L1sqd"};